import React from 'react'

const MoveIns = () => {
  return (
    <div className='MoveIns'>
        <p>You have no upcoming move ins.</p>
    </div>
  )
}

export default MoveIns